import { FabrixNotice, FabrixNoticeService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface FabrixNoticeOptions extends ControllerOptions<FabrixNotice> {
   
}

export const initializeFabrixNotice = () => {
    let tr: FabrixNotice = {
        name: "",
        notice: "",
        type: "info",
        active: true
    }
    return tr;
}

export const FabrixNoticeType = ["warning", "info", "error"]

export class ClientNoticeService extends BaseClientService implements DataController<FabrixNotice> {

    private _service: FabrixNoticeService;

    constructor() {
        super()
        this._service = new FabrixNoticeService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
  

    public async get(options: FabrixNoticeOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }

    public async show() {
        return await this._service.show(this.token)
    }


    public async getById(options: FabrixNoticeOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: FabrixNoticeOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }

    public async update(options: FabrixNoticeOptions) {
        if (options.item)
            return await this._service.update(options.item, this.token);
        return null;
    }


    public async delete(options: FabrixNoticeOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }


}